import { Component, input } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslatePipe } from "@ngx-translate/core";
import { KENDO_NUMERICTEXTBOX, KENDO_TEXTBOX } from "@progress/kendo-angular-inputs";
import { ChangedFieldDirective } from "../../changed-field.directive";
import { HoistArray } from "./hoist-group";

/** The hoists mounted on the flight: what it used of each, by its serial and name. */
@Component({
    selector: "app-hoist-tab",
    imports: [ChangedFieldDirective, ReactiveFormsModule, TranslatePipe, KENDO_NUMERICTEXTBOX, KENDO_TEXTBOX],
    templateUrl: "./hoist-tab.component.html",
    styleUrl: "../../edit-fields.scss",
})
export class HoistTabComponent {
    readonly rows = input.required<HoistArray>();
    /** Each hoist by its serial and name, or whichever of the two the logbook has. */
    readonly labels = input.required<string[]>();
}
